module.exports = __webpack_public_path__ + "static/media/0-9.729eeade.svg";